import { render, staticRenderFns } from "./SupplierFda.vue?vue&type=template&id=2ae41fd3"
import script from "./SupplierFda.vue?vue&type=script&lang=js"
export * from "./SupplierFda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports